import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { Field, Form } from 'redux-form';
import { get, union } from 'lodash';
import axios from 'axios';
import { connect } from 'react-redux';
import {
  accreditationTypes,
  accreditationStatuses,
  countries,
  bankPaymentTypes,
  cryptoPaymentTypes,
  formatCurrency,
  formatCryptoCurrency,
  parseNumber,
  paymentMethods,
  SelectableButtonGroup,
  SelectableRadioButtonGroup,
  selectOptions,
} from 'entoro-shared';
import { Grid, withStyles, Button } from 'material-ui';
import Typography from 'material-ui/Typography';
import {
  CRYPTO_COMPARE_URL,
  CRYPTO_COMPARE_KEY,
  ACH_MAX_LIMIT,
  CARD_MAX_LIMIT,
} from '../../../../../config';
import { FormControl, FormHelperText } from 'material-ui/Form';
import MaterialTextField from 'material-ui/TextField';
import { MenuItem } from 'material-ui/Menu';
import Select from 'material-ui/Select';
import { InputLabel } from 'material-ui/Input';
import {
  setCrowdfundingInvestors,
  setCrowdfundModal,
} from '../../../../../redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Dialog, {
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

import List, { ListItem, ListItemText, ListItemAvatar } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import Slide from 'material-ui/transitions/Slide';

const styles = (theme) => ({
  headerHR: {
    borderBottom: '1px solid #4d5e75',
    marginBottom: '16px',
  },
  title: {
    fontSize: '16px',
    margin: 0,
  },
  equal: {
    color: theme.palette.secondary.main,
    fontSize: 20,
    margin: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textFieldRoot: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  textFieldInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  selectPadding: {
    padding: ' 3px',
  },
  InputLabelStyle: {
    top: '-10px',
    left: ' 10px',
  },
  crowdfundingQuestion: {
    boxShadow: 'none !important',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    position: 'relative',
    zIndex: 2,
    margin: '0 !important',
    // backgroundColor: '#fd5190',
    border: '1px solid #ced4da',
    fontSize: '0.9375rem',
    lineHeight: 1.5,
    borderRadius: '0.25rem',
    transition:
      'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
  },
  listItemTextRoot: {
    fontSize: '16px',
    '& .MuiTypography-subheading-53': {
      fontSize: '15px',
    },
  },
  avatar: {
    margin: 10,
    // background: '#242121',
  },
  toolbarRoots: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogcontentRoot: {
    padding: '20px 0px 0px 24px',
  },
  formControlMargin: {
    marginBottom: '10px',
  },
});
const formatAllCurrency = (value, currency = 'USD') => {
  // Validate currency code
  const currencyCodes = new Set(Intl.supportedValuesOf('currency'));
  const validCurrencyCode = currencyCodes.has(currency) ? currency : 'USD';

  // Format the value with respect to the specified currency
  const currencySymbols = Array.from(currencyCodes)
    .map((currencyCode) => {
      try {
        return Intl.NumberFormat('en', {
          style: 'currency',
          currency: currencyCode,
        })
          .formatToParts(0)
          .find((part) => part.type === 'currency');
      } catch (error) {
        return undefined;
      }
    })
    .filter((currencySymbol) => currencySymbol !== undefined);

  const currencySymbol = currencySymbols.find(
    (symbol) => symbol !== undefined && symbol.unit === validCurrencyCode
  );

  const formattedValue = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: validCurrencyCode,
    currencyDisplay: 'symbol',
    currencySign: 'accounting',
    ...(currencySymbol && { currencyDisplay: 'code' }),
  }).format(value);

  return formattedValue;
};
const DropDownMenu = ({
  input,
  label,
  helperText,
  required,
  multiple,
  options,
  styleInput,
  meta: { touched, error },
}) => {
  const displayedOptions = !required
    ? [
        {
          label: '',
          value: null,
        }, // Ability to deselect
        ...options,
      ]
    : options;

  return (
    <FormControl fullWidth>
      <InputLabel
        classes={{ formControl: styleInput.InputLabelStyle }}
        required={required}
        error={Boolean(touched && error)}
      >
        Select
      </InputLabel>

      <Select
        multiple={multiple}
        value={input.value || []}
        onChange={input.onChange}
        className={styleInput.crowdfundingQuestion}
        classes={{
          root: styleInput.selectPadding,
        }}
        InputProps={{
          disableUnderline: true,
        }}
      >
        {displayedOptions.map(({ label, value }) => (
          <MenuItem
            className='form-field-dropdown-menu-item'
            key={value || 'deselect'}
            value={value}
            style={{
              fontWeight: input.value.indexOf(value) !== -1 ? '500' : 'initial',
              backgroundColor:
                input.value.indexOf(value) !== -1
                  ? 'rgba(0, 0, 0, 0.12)'
                  : 'initial',
            }}
          >
            {label || ''}
          </MenuItem>
        ))}
      </Select>
      {(helperText || (touched && error)) && (
        <FormHelperText error={Boolean(touched && error)}>
          {touched && error ? error : helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const CurrencyInput = ({
  input,
  meta: { touched, error },
  styleInput,
  ...custom
}) => {
  return (
    <FormControl
      classes={{ root: styleInput.formControlMargin }}
      fullWidth
      error={Boolean(touched && error)}
    >
      <MaterialTextField
        {...input}
        error={Boolean(touched && error)}
        fullWidth
        {...custom}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: styleInput.textFieldRoot,
            input: styleInput.textFieldInput,
          },
        }}
      />
      {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
};

const MySwal = withReactContent(Swal);
const paymentOptions = {
  BANK: bankPaymentTypes.options,
  CRYPTO: cryptoPaymentTypes.options,
};

class InvestmentDetails extends React.Component {
  state = {
    loading: false,
    displayForm: false,
  };

  emailValidation = (value) =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? (
      <span style={{ color: 'red' }}>Invalid email address</span>
    ) : undefined;

  renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
    <div>
      <label>{label}</label>
      <div>
        <input
          {...input}
          placeholder={label}
          type={type}
          style={{
            backgroundColor: '#ffffff',
            borderColor: '#ced4da',
            borderRadius: '4px',
            borderStyle: 'solid',
            borderWidth: '1px',
            color: '#000000',
            lineHeight: '20px',
            padding: '10px 12px',
            width: '100% !important',
          }}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  render() {
    const {
      disabled,
      change,
      handleSubmit,
      selectedPaymentMethod,
      selectedPaymentType,
      paymentDetails,
      crowdfunding,
      dispatch,
      offer,
      classes,
      initialValues: {
        toggleSecondSigner,
        secondSignerEmail,
        secondSignerName,
        subscriptionAgreementStatus,
        agreementEnvelopeId,
        paymentMethod,
        paymentType,
        crowdfundingQuestion,
      },
      income,
      networth,
      crowdfundModal,
      investorUser: {
        firstName,
        lastName,
        accreditationType,
        accreditationStatus,
        country,
        mobilePhoneNumber,
        email,
        address,
        selectedOptionTypes,
      },
    } = this.props;

    const formatMoney = (input) => {
      if (!input) return;
      const removeNan = input.toString().replace(/[^0-9]/g, '');
      const convertedInput = new Intl.NumberFormat().format(removeNan);
      return '$ ' + convertedInput;
    };
    const normalizeAmount = (val) => {
      return val.replace(/[^a-zA-Z 0-9.]+/g, '');
    };

    function Transition(props) {
      return <Slide direction='up' {...props} />;
    }
    let limitations = 'N/A';
    if (networth < '107000' || income < '107000') {
      limitations = (Math.max(Number(networth), Number(income)) * 5) / 100;
    } else if (networth > '107000' && income > '107000') {
      limitations = (Math.max(Number(networth), Number(income)) * 10) / 100;
    }

    const formatCurrencyWithCrypto = (number) => {
      const url = `${CRYPTO_COMPARE_URL}&api_key=${CRYPTO_COMPARE_KEY}`;
      const crypto = selectedPaymentType.includes('CRYPTO');
      const cryptoType = selectedPaymentType.replace('CRYPTO_', '');
      let investmentAmountCrypto = 0;

      axios(url)
        .then((res) => {
          const cryptoPrice = get(res.data[cryptoType], 'USD');
          if (number && crypto && cryptoPrice) {
            investmentAmountCrypto = formatCryptoCurrency(number / cryptoPrice);
          }

          change('investmentAmountCrypto', investmentAmountCrypto);
        })
        .catch((error) => {
          console.error('Error fetching crypto prices: ', error); // eslint-disable-line no-console
          change('investmentAmountCrypto', investmentAmountCrypto);
        });

      return formatCurrency(number);
    };

    const formatCrypto = (number) => {
      const crypto = selectedPaymentType.includes('CRYPTO');
      const cryptoType = selectedPaymentType.replace('CRYPTO_', '');

      if (crypto && cryptoType && number) {
        return `${number} ${cryptoType}`;
      }

      return 'N/A';
    };

    const { acceptedPaymentMethod, acceptedBankTypes, acceptedCryptoTypes } =
      paymentDetails;

    const paymentMethodOptions = () =>
      paymentMethods.options.filter(({ value }) =>
        acceptedPaymentMethod.includes(value)
      );

    const paymentTypeOptions = () =>
      paymentOptions[selectedPaymentMethod].filter(({ value }) =>
        union(acceptedBankTypes, acceptedCryptoTypes).includes(value)
      );
    const popupWhyInstruction = () => {
      dispatch(setCrowdfundModal(true));
    };
    const popupHandleClose = () => {
      dispatch(setCrowdfundModal(false));
    };

    const MAX_INVESTMENT_AMOUNT =
      selectedPaymentType === 'BANK_WIRE' ? CARD_MAX_LIMIT : ACH_MAX_LIMIT;

    return (
      <React.Fragment>
        <Dialog
          open={crowdfundModal.crowdfundModal}
          onClose={popupHandleClose}
          TransitionComponent={Transition}
          keepMounted
        >
          <Toolbar
            classes={{
              root: classes.toolbarRoots,
            }}
          >
            <DialogTitle>{'Latest Rules and Regulations'}</DialogTitle>
            <IconButton
              color='inherit'
              onClick={popupHandleClose}
              aria-label='Close'
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <DialogContent>
            <DialogContentText
              classes={{
                root: classes.dialogcontentRoot,
              }}
            >
              Regulation Crowdfunding became legal on May 2016. The limits can
              be complicated, but here's the gist.
            </DialogContentText>
            <List>
              <ListItem button>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>1</Avatar>
                </ListItemAvatar>
                <ListItemText
                  classes={{
                    root: classes.listItemTextRoot,
                  }}
                  primary='Everyone can invest at least $2,200'
                />
              </ListItem>
              <Divider />
              <ListItem button>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>2</Avatar>
                </ListItemAvatar>
                <ListItemText
                  classes={{
                    root: classes.listItemTextRoot,
                  }}
                  primary='If either your net worth or income are below $107,000, you may legally invest a maximum of 5% of the greater number'
                />
              </ListItem>
              <Divider />
              <ListItem button>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>3</Avatar>
                </ListItemAvatar>
                <ListItemText
                  classes={{
                    root: classes.listItemTextRoot,
                  }}
                  primary='If both your net worth and income are above $107,000, you may legally invest a maximum of 10% of the greater number'
                />
              </ListItem>
              <Divider />
              <ListItem button>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>4</Avatar>
                </ListItemAvatar>
                <ListItemText
                  classes={{
                    root: classes.listItemTextRoot,
                  }}
                  primary='Non-accredited Investors may not invest more than $107,000. Accredited Investors may invest as much as they wish'
                />
              </ListItem>
              <Divider />
              <ListItem button>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>5</Avatar>
                </ListItemAvatar>
                <ListItemText
                  classes={{
                    root: classes.listItemTextRoot,
                  }}
                  primary=' Investment limits are for any given trailing 12-month period. Every other investment in a Regulation Crowdfunding offering counts towards the annual limit'
                />
              </ListItem>
            </List>
          </DialogContent>
        </Dialog>

        <div className='step'>
          <Grid container>
            <Grid item xs={12} className={classes.headerHR}>
              <p className={classes.title}>Your Account</p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container>
                <Grid item xs={4}>
                  <b>Name</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{`${firstName} ${lastName}`}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <b>Account Type</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>
                    {accreditationTypes.getLabel(accreditationType)}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <b>Status</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>
                    {country === 'US'
                      ? 'United States Citizen'
                      : 'Non-US Citizen'}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <b>Accreditation</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>
                    {accreditationStatuses.getLabel(accreditationStatus)}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <b>Country</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{countries.getLabel(country)}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container>
                <Grid item xs={4}>
                  <b>Phone</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>
                    {
                      <NumberFormat
                        format='+# (###) ###-####'
                        mask='_'
                        displayType='text'
                        value={mobilePhoneNumber}
                      />
                    }
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <b>Email Address</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{email}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <b>Address</b>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{address}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Form onSubmit={handleSubmit}>
            <div className='payment-methods'>
              <h3 className='payment-methods__title'>Payment Method</h3>
              <p className='payment-methods__description'>
                Select a payment method for this investment
              </p>
            </div>
            <div>
              <Field
                disabled={disabled}
                className='radio-select'
                component={SelectableRadioButtonGroup}
                name='paymentMethod'
                options={paymentMethodOptions()}
                normalize={(value) => {
                  if (value === paymentMethod) {
                    change('paymentType', paymentType);
                  } else {
                    change('paymentType', null);
                  }
                  if (value !== 'CRYPTO') {
                    change('investmentAmountCrypto', 0);
                  }
                  return value;
                }}
              />
            </div>
            <div>
              <Field
                disabled={disabled}
                component={SelectableButtonGroup}
                name='paymentType'
                options={paymentTypeOptions()}
              />
            </div>

            <div>
              {selectedOptionTypes !== 'YES' &&
                (offer.typeOfOffer !== 'REG_D' ||
                  offer.typeOfOffer !== 'Reg_D_506c' ||
                  offer.typeOfOffer !== 'Reg_D_506b' ||
                  !offer.typeOfOffer) && (
                  <Grid container justify='space-between' alignItems='center'>
                    <Grid item xs={12} sm={5}>
                      <h2 className='invest-detail-text-header'>
                        Annual Income
                      </h2>
                      <p className='help-text'>
                        Your current Annual Income is the total amount of gross
                        income earned in one year from all sources before taxes.
                      </p>
                      <Field
                        disabled={disabled}
                        component={CurrencyInput}
                        placeholder='What is your Income?'
                        format={formatMoney}
                        normalize={normalizeAmount}
                        name='income'
                        autoComplete='off'
                        styleInput={classes}
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <h2 className='invest-detail-text-header'>Net Worth</h2>
                      <p className='help-text'>
                        Your Net Worth does not include the value of your
                        primary residence.{' '}
                      </p>
                      <Field
                        disabled={disabled}
                        component={CurrencyInput}
                        placeholder='What is your Net Worth?'
                        format={formatMoney}
                        normalize={normalizeAmount}
                        name='networth'
                        styleInput={classes}
                        autoComplete='off'
                      />
                    </Grid>
                  </Grid>
                )}
            </div>
            {selectedOptionTypes !== 'YES' &&
              (offer.typeOfOffer !== 'REG_D' ||
                offer.typeOfOffer !== 'Reg_D_506c' ||
                offer.typeOfOffer !== 'Reg_D_506b' ||
                !offer.typeOfOffer) &&
              offer.typeOfOffer !== 'REG_A' && (
                <React.Fragment>
                  <div className='help-info-container'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0-2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.997 9.004h-2.009v6h2.009v-6zm-2.009-4h2.009v2.009h-2.009v-2.01z'
                        fill='currentColor'
                      ></path>
                    </svg>
                    <p className='help-text-info'>
                      For all Reg CF offerings in a given 12-month period, your
                      combined annual investment limit starts at a minimum of
                      $2,200 and runs to as high as 5% of the greater of your
                      annual income or your net worth, if both are less than
                      $107,000. If both are more than $107,000, your limit is
                      instead 10% of the greater of your annual income or your
                      net worth.
                    </p>
                  </div>

                  <div>
                    <h2 className='invest-detail-text-header'>
                      Have you invested on other crowdfunding platforms in the
                      past 12 months?
                    </h2>
                    <div className='crowdfunding-container'>
                      <div className='crowdfunding-question'>
                        <Field
                          component={DropDownMenu}
                          name='crowdfundingQuestion'
                          styleInput={classes}
                          options={selectOptions.options}
                          required='true'
                          onChange={(el, val) =>
                            dispatch(setCrowdfundingInvestors(val))
                          }
                        />
                      </div>
                      {(crowdfunding.crowdfundingInvestor === 'YES' ||
                        crowdfundingQuestion === 'YES') && (
                        <div className='crowdfunding-amount'>
                          <Field
                            component={CurrencyInput}
                            name='crowdfundingAmount'
                            placeholder='How much?'
                            format={formatMoney}
                            normalize={normalizeAmount}
                            disabled={disabled}
                            styleInput={classes}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {(crowdfunding.crowdfundingInvestor === 'YES' ||
                    crowdfundingQuestion === 'YES') && (
                    <div className='limit-info-container'>
                      <svg viewBox='0 0 40 40'>
                        <path
                          d='M34.5,6C32,6,30,8,30,10.5c0,1.1,0.4,2.1,1.1,2.9l-4.3,7.6C26.5,21,26.3,21,26,21c-0.9,0-1.6,0.3-2.3,0.7L19.2,18
    c0.2-0.5,0.3-1,0.3-1.5c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5c0,0.9,0.3,1.8,0.8,2.5l-4.5,6.2C6.4,25.1,5.9,25,5.5,25
    C3,25,1,27,1,29.5S3,34,5.5,34s4.5-2,4.5-4.5c0-0.9-0.3-1.8-0.8-2.5l4.5-6.2c0.4,0.1,0.8,0.2,1.3,0.2c0.9,0,1.6-0.3,2.3-0.7l4.5,3.7
    c-0.2,0.5-0.3,1-0.3,1.5c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5c0-1.1-0.4-2.1-1.1-2.9l4.3-7.6c0.3,0,0.5,0.1,0.8,0.1
    c2.5,0,4.5-2,4.5-4.5S37,6,34.5,6z M5.5,31c-0.1,0-0.3,0-0.4-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.3-0.1-0.4-0.2c0,0,0,0,0,0
    c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1
    c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1C4.5,28.3,5,28,5.5,28C6.3,28,7,28.7,7,29.5c0,0.4-0.1,0.7-0.3,0.9
    c0,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0
    C5.7,31,5.6,31,5.5,31C5.5,31,5.5,31,5.5,31z M15,18c-0.8,0-1.5-0.7-1.5-1.5c0-0.4,0.1-0.7,0.4-1c0,0,0.1-0.1,0.1-0.1
    c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0
    c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1
    c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.4,0.3,0.6,0.7,0.6,1.2C16.5,17.3,15.8,18,15,18z M25.9,27c-0.1,0-0.1,0-0.2,0
    c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.4-0.3-0.6-0.7-0.6-1.2c0-0.8,0.7-1.5,1.5-1.5
    s1.5,0.7,1.5,1.5c0,0.3-0.1,0.6-0.2,0.8c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1
    c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1c0,0-0.1,0-0.1,0C26.1,27,26,27,25.9,27C25.9,27,25.9,27,25.9,27z
     M33,10.5c0-0.3,0.1-0.6,0.2-0.8c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1
    c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0
    c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1
    c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1
    c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c-0.2,0.5-0.8,0.8-1.3,0.8C33.7,12,33,11.3,33,10.5z'
                        ></path>
                      </svg>
                      <p className='limit-text-info'>
                        <span> Your 12-month Reg CF Investment Limit is </span>
                        {formatCurrency(limitations)}
                      </p>

                      <div className='popup_why'>
                        <button onClick={popupWhyInstruction}>Why?</button>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              )}

            <div>
              <h2 className='invest-detail-text-header'>
                How much do you wish to invest in this offering? USD
              </h2>
              {offer.minimumInvestment && (
                <p className='help-text'>
                  Minimum Investment for this deal is{' '}
                  <b>
                    {formatAllCurrency(
                      offer.minimumInvestment,
                      offer.offerCurrency
                    )}
                  </b>
                  {/* {selectedPaymentMethod === 'BANK' && selectedPaymentType && (
                    <span>
                      {' '}
                      and Maximum investment for this offer is{' '}
                      <b>{formatCurrency(+MAX_INVESTMENT_AMOUNT)}</b>{' '}
                    </span>
                  )} */}
                </p>
              )}

              {selectedPaymentMethod === 'BANK' && (
                <Field
                  disabled={disabled}
                  component={CurrencyInput}
                  format={formatCurrency}
                  parse={parseNumber}
                  name='investmentAmount'
                  autoComplete='off'
                  styleInput={classes}
                />
              )}
              {selectedPaymentMethod === 'CRYPTO' && (
                <Grid container alignItems='flex-start'>
                  <Grid item xs={12} sm={5}>
                    <Field
                      disabled={disabled}
                      name='investmentAmount'
                      component={CurrencyInput}
                      format={
                        disabled ? formatCurrency : formatCurrencyWithCrypto
                      }
                      parse={parseNumber}
                      styleInput={classes}
                      autoComplete='off'
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <b className={classes.equal}>&#61;</b>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <Field
                      name='investmentAmountCrypto'
                      component={CurrencyInput}
                      format={formatCrypto}
                      styleInput={classes}
                      disabled
                    />
                  </Grid>
                </Grid>
              )}
              {selectedPaymentMethod === 'ALTOIRA' && (
                <Button
                  label='Invest with Alto SDIRA'
                  color='primary'
                  href='#'
                  target='_blank'
                  style={{
                    margin: '10px 0',
                    position: 'relative',
                    background: '#862fa4',
                    color: 'white',
                  }}
                >
                  Invest with Alto SDIRA
                </Button>
              )}
            </div>

            <div>
              <h2 className='invest-detail-text-header'>
                Do you wish to add Joint Signer?
              </h2>

              <Button
                className='action-button'
                onClick={() => {
                  this.setState({ ...this.state, displayForm: true });
                }}
                disabled={toggleSecondSigner}
              >
                Add Joint Signer
              </Button>

              {toggleSecondSigner || this.state.displayForm ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '1.5rem',
                  }}
                >
                  <div>
                    <Field
                      name='secondSignerName'
                      component={this.renderField}
                      type='text'
                      label='Signer Name'
                    />
                  </div>
                  <div>
                    <Field
                      name='secondSignerEmail'
                      component={this.renderField}
                      type='email'
                      validate={this.emailValidation}
                      label='Signer Email'
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

InvestmentDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  investorUser: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  paymentDetails: PropTypes.object.isRequired,
  selectedPaymentMethod: PropTypes.string.isRequired,
  selectedPaymentType: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

InvestmentDetails.defaultProps = {
  disabled: false,
};

const mapStateToProps = (state) => ({
  crowdfunding: state.crowdfunding,
  crowdfundModal: state.crowdfundModal,
});

export default connect(mapStateToProps)(withStyles(styles)(InvestmentDetails));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/InvestmentDetails.js